// extracted by mini-css-extract-plugin
export default {"lanta_Container":"LentaPage_lanta_Container__Fz9j0","lenta_search_bar_container":"LentaPage_lenta_search_bar_container__pw2XA"};